/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Text, theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { InlineEditDropdown } from "~/components/InlineEdit/InlineEditDropdown";
import { envStatusOptions } from "~/constants";
import { AssignmentRuleFlat } from "~/models";
import { displayEnvStatus } from "~/tools";
import { AREnvStatusClear } from "./EnvStatusClear";

type Props = {
  item: AssignmentRuleFlat;
  onSubmit: (values: AssignmentRuleFlat) => Promise<void>;
  refetch: () => Promise<void>;
  canEdit?: boolean;
};

function InlineDropdownAREnvStatus({
  item,
  onSubmit,
  refetch,
  canEdit = true,
}: Props) {
  const DisplayText = (
    <>
      <Text as="div" m="0">
        <FlexContainer>
          {item.environmentStatus ? (
            displayEnvStatus(item.environmentStatus)
          ) : (
            <Text mt="0.2rem" tag="span" color={theme.colors.warning}>
              Not set
            </Text>
          )}
        </FlexContainer>
      </Text>

      {!!item.environmentStatus && (
        <AREnvStatusClear assignmentRule={item} refetch={refetch} />
      )}
    </>
  );

  return (
    <InlineEditDropdown
      name="Status"
      options={envStatusOptions}
      defaultValue={item.environmentStatus}
      display={DisplayText}
      onSubmit={(value) => onSubmit({ ...item, environmentStatus: value })}
      canEdit={canEdit}
    />
  );
}

export { InlineDropdownAREnvStatus };
